import React from "react"
import { FormHelpers } from "./form_helpers"
import { YES, NO, YES_OR_NO } from "../data"


export interface YesNoQuestionProps {
  name: string
  text: string
  required?: boolean
  subquestion?: string
  value?: YES_OR_NO | null
  onChange: (value: YES_OR_NO) => void
}
export function YesNoQuestion(props: YesNoQuestionProps) {
  const name = props.name
  const text = props.text
  // eslint-disable-next-line no-extra-boolean-cast -- not important to fix
  const required = !!props.required ? true : false

  let subquestion: React.ReactNode
  if (props.subquestion) {
    subquestion = text
  } else {
    subquestion = <span className="horizontal-question">{text}</span>
  }

  const notEmpty = required

  const dataShow = `.show-${name}`

  const value = props.value || ""

  const yesChecked = FormHelpers.str2bool(value) === true
  const noChecked = FormHelpers.str2bool(value) === false

  const hasSubquestion = subquestion || (typeof subquestion === "string" && subquestion.length > 0)
  const labelId = `radiogroup_${name}_label`

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.currentTarget.value as YES_OR_NO)
  }

  return (
    <div className="form-group" role="radiogroup" aria-labelledby={hasSubquestion ? labelId : ""}>
      {hasSubquestion ? (
        <div className="col-sm-8">
          <span id={labelId} className={required ? "required" : ""}>
            {subquestion}
          </span>
        </div>
      ) : (
        <div className="col-sm-1" />
      )}

      <div className="col-sm-2">
        <div className="radio radio-yes">
          <label>
            {/* React normalizes onClick to onChange, see: https://reactjs.org/docs/dom-elements.html#onchange */}
            <input
              type="radio"
              onChange={onChange}
              className="qualifier-radio"
              name={name}
              value={YES}
              defaultChecked={yesChecked}
              data-show={dataShow}
              data-fv-notempty={notEmpty}
              required={required}
              data-fv-ignore-error-message={true}
              data-fv-notempty-message=""
            />
            Yes
          </label>
        </div>
      </div>

      <div className="col-sm-2">
        <div className="radio radio-no">
          <label>
            <input
              type="radio"
              onChange={onChange}
              className="qualifier-radio"
              name={name}
              value={NO}
              defaultChecked={noChecked}
              data-show={dataShow}
              data-fv-notempty={notEmpty}
              required={required}
              data-fv-ignore-error-message={true}
              data-fv-notempty-message=""
            />
            No
          </label>
        </div>
      </div>
    </div>
  )
}
